export const PAGE_SIZE = 5;
export const MOBILE_OFFSET_SCROLL = 300;
export const DESKTOP_OFFSET_SCROLL = 260;
export const HOW_REFUNDS_WORK_LINK = "How do refunds work?";
export const HOW_REFUNDS_WORK_TEXT =
  "If eligible, a refund will be issued to your original payment method and should be received within the next 1-2 billing cycles.";